import * as React from 'react';
import { observer } from 'mobx-react';
import { PortalAsideLink } from '../../layout/Aside/PortalAsideLink';
import { PortalAsideCategory } from '../../layout/Aside/PortalAsideCategory';
import { PortalAsideHeading } from '../../layout/Aside/PortalAsideHeading';
import { PortalAsideCategoryItem } from '../../layout/Aside/PortalAsideCategoryItem';
import { StoreContext } from '../../utils';
import { LehrerAsideAnonym } from './LehrerAsideAnonym';
import { Store } from '../../store/Store';

@observer
export class LehrerAside extends React.Component {
  static contextType = StoreContext;
  declare context: Store;

  render() {
    const { lehrerStore } = this.context;
    const { lehrer, gruppen } = lehrerStore;

    if (!lehrer) {
      return <LehrerAsideAnonym />;
    }

    return (
      <>
        <PortalAsideLink title={<span className="kt-font-primary">{lehrer && lehrer.name}</span>} href="/lehrer" icon="flaticon2-user" />

        <PortalAsideHeading title="Gruppen" />
        {gruppen.length > 0 && (
          <PortalAsideCategory
            title="Meine Gruppen"
            badge={lehrerStore.gruppen.length || ''}
            icon="flaticon2-browser-2"
            href=""
            openIfPathIncludes="gruppe"
          >
            {lehrerStore.gruppen.map(gruppe => {
              return (
                <PortalAsideCategory
                  title={gruppe.name}
                  icon="flaticon-users"
                  href=""
                  openIfPathIncludes={gruppe.gruppecode}
                  key={gruppe.name}
                >
                  <PortalAsideCategoryItem
                    title="Mitglieder "
                    icon="flaticon2-avatar"
                    href={`/lehrer/gruppe/${gruppe.gruppecode}/mitglieder`}
                  />
                  <PortalAsideCategoryItem
                    title="Arbeitsaufträge"
                    icon="flaticon2-avatar"
                    href={`/lehrer/gruppe/${gruppe.gruppecode}/vorgaben`}
                  />
                  <PortalAsideCategoryItem
                    title="Schülerzugänge"
                    icon="flaticon2-avatar"
                    href={`/lehrer/gruppe/${gruppe.gruppecode}/zugang`}
                  />
                  <PortalAsideCategoryItem
                    title="Auswerten"
                    icon="flaticon2-avatar"
                    href={`/lehrer/gruppe/${gruppe.gruppecode}/auswertung`}
                  />
                  <PortalAsideCategoryItem
                    title="Einstellungen"
                    icon="flaticon2-gear"
                    href={`/lehrer/gruppe/${gruppe.gruppecode}/einstellungen`}
                  />
                </PortalAsideCategory>
              );

              return (
                <PortalAsideCategoryItem
                  key={gruppe.id}
                  title={gruppe.name}
                  icon="flaticon2-browser-2"
                  href={`/lehrer/gruppe/${gruppe.id}`}
                />
              );
            })}
          </PortalAsideCategory>
        )}
        <PortalAsideLink title="Gruppe anlegen" href="/lehrer/gruppe/anlegen" icon="flaticon2-plus" />
      </>
    );
  }
}
